// extracted by mini-css-extract-plugin
module.exports = {"sponsorLogo":"SponsorStream_sponsorLogo__3kp7g","button":"SponsorStream_button__1s5F2"};